export default __webpack_public_path__ + "static/media/platform.a3835660.png";